// Vendor libraries loaded from npm and exposed as globals for legacy-style usage.
import "tabulator-tables/dist/css/tabulator.min.css";
import {
  Tabulator,
  EditModule,
  FilterModule,
  FormatModule,
  PageModule,
  SelectRowModule,
  SortModule,
  AjaxModule,
  MoveColumnsModule,
  ResizeColumnsModule,
  InteractionModule,
} from "tabulator-tables";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "@fortawesome/fontawesome-free/css/all.min.css";

(Tabulator as any).registerModule([
  EditModule,
  FilterModule,
  FormatModule,
  PageModule,
  SelectRowModule,
  SortModule,
  AjaxModule,
  MoveColumnsModule,
  ResizeColumnsModule,
  InteractionModule,
]);

(window as any).Tabulator = Tabulator;
(window as any).XLSX = XLSX;
(window as any).Papa = Papa;
